export function initMobieFilter() {
  const mobileZone = document.querySelector('.po-intro__mobile-zone');
  const desktopCatSummary = document.querySelector(
    '.po-intro__wrapper .po-intro__cat-summary'
  );
  const searchWrapper = document.querySelector('.po-intro__search-wrapper');
  const sliderPaginations = document.querySelectorAll(
    '.po-post-slider__pagination.splide__pagination'
  );
  const sliderArrows = document.querySelectorAll(
    '.splide__arrows.po-post-slider__arrows.splide__arrows--ltr'
  );

  if (!mobileZone || !desktopCatSummary || !searchWrapper) return;

  function toggleMobileFilter() {
    if (window.innerWidth < 1280) {
      mobileZone.classList.remove('hidden');
      desktopCatSummary.classList.add('hidden');
      searchWrapper.classList.add('hidden');
      sliderPaginations.forEach((p) => p.classList.add('hidden'));
      sliderArrows.forEach((a) => a.classList.add('hidden'));

      const container = mobileZone.querySelector('.po-cat-group-summary');
      const lang = window.PO_LANG || 'en';

      if (container && container.innerHTML.trim() === '') {
        fetch(
          // `/wp-json/po/v1/mobile-categories?lang=${encodeURIComponent(
          `/blog/wp-json/po/v1/mobile-categories?lang=${encodeURIComponent(
            lang
          )}`
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.success) container.innerHTML = data.data;
          });
      }
    } else {
      mobileZone.classList.add('hidden');
      desktopCatSummary.classList.remove('hidden');
      searchWrapper.classList.remove('hidden');
      sliderPaginations.forEach((p) => p.classList.remove('hidden'));
      sliderArrows.forEach((a) => a.classList.remove('hidden'));
    }
  }

  toggleMobileFilter();
  window.addEventListener('resize', toggleMobileFilter);
}
